import React, { ChangeEvent, CSSProperties, ReactNode, useState } from "react";
import { AppFormErrorMessages } from "src/commun/composants/formulaire/AppFormErrorMessage/AppFormErrorMessage";
import styles from "./AppCheckbox.scss";

export type AppCheckboxProps = {
  name: string;
  onChange: (param: any) => void;
  value: string;
  checked?: boolean;
  checkedManagedFromParent?: boolean;
  disabled?: boolean;
  label?: ReactNode;
  error?: string;
  children?: ReactNode;
  styleCheckbox?: CSSProperties;
  styleLabel?: string;
} & React.ComponentProps<"input">;

const AppCheckbox = ({
  name,
  onChange,
  value,
  checked,
  checkedManagedFromParent = false,
  disabled,
  label,
  error,
  styleCheckbox = {},
  styleLabel,
  ...reste
}: AppCheckboxProps) => {
  const [isChecked, setIsChecked] = useState(checked || false);
  const changeHandler = (event: ChangeEvent<HTMLInputElement>) => {
    event.persist();
    setIsChecked((prevChecked) => !prevChecked);
    if (onChange) {
      onChange(event);
    }
  };

  const labelStyle = styleLabel ? styleLabel : styles.InputLabelLabel;

  // Generation d'un id unique pour éviter les conflits lorsque plusieurs checkbox sont presentes sur une meme page
  const id = name + Math.random().toString(36).slice(-5);

  return (
    <>
      <div className={styles.Item}>
        <label
          className={`${styles.InputCheckboxLabel} ${
            disabled ? styles.disabled : ""
          }`}
          htmlFor={id}
        >
          <input
            name={name}
            id={id}
            onChange={changeHandler}
            value={value}
            checked={checkedManagedFromParent ? checked : isChecked}
            disabled={disabled}
            {...reste}
            className={styles.CheckboxHidden}
          />
          <div
            className={`${styles.CheckboxDisplay} ${
              disabled ? styles.disabled : ""
            }`}
            style={styleCheckbox}
          />
          {label && (
            <label
              className={`${labelStyle} ${disabled ? styles.disabled : ""}`}
            >
              {label}
            </label>
          )}
        </label>
      </div>
      {error && (
        <div>
          <AppFormErrorMessages erreurs={error} />
        </div>
      )}
    </>
  );
};

export default AppCheckbox;
